import ARFlag from '@/assets/flags/AR.svg'
import BOFlag from '@/assets/flags/BO.svg'
import BRFlag from '@/assets/flags/BR.svg'
import CLFLag from '@/assets/flags/CL.svg'
import COFlag from '@/assets/flags/CO.svg'
import ECFlag from '@/assets/flags/EC.svg'
import ITFlag from '@/assets/flags/IT.svg'
import MXFlag from '@/assets/flags/MX.svg'
import PEFlag from '@/assets/flags/PE.svg'
import PYFlag from '@/assets/flags/PY.svg'
import UYFlag from '@/assets/flags/UY.svg'
import { Country } from '../constants/countries'

export function countryCodeToFlag(countryCode?: Country): string {
  const flagMap: Record<Country, string> = {
    BR: BRFlag,
    AR: ARFlag,
    IT: ITFlag,
    PY: PYFlag,
    CO: COFlag,
    BO: BOFlag,
    EC: ECFlag,
    MX: MXFlag,
    PE: PEFlag,
    UY: UYFlag,
    CL: CLFLag,
  }

  return (countryCode && flagMap[countryCode]) || ''
}
